import { Box } from "@mui/material";
import HeroSection from "./hero-section";
import HowItWorks from "pages/Home/HowItWorks";
import FAQComponentSection from "pages/Home/FAQSECTION";
import Benefits from "./benefits";
import { Helmet } from "react-helmet";

const ListEquipmentPublic = () => {
  return (
    <Box>
      <Helmet>
        <title>Rent Your Farm Tractor & Equipments in USA - Haystackers</title>
        <meta
          name="description"
          content="Looking for renting your tractor, attachment or farm equipment in Illinois Usa? Lease your tractor online to needy farmers and earn passive income with Haystackers."
        />
        <link
          rel="canonical"
          href="https://haystackers.com/owner-list-tractor"
        />
      </Helmet>
      <HeroSection />
      <Benefits />
      <HowItWorks />
      <FAQComponentSection />
    </Box>
  );
};

export default ListEquipmentPublic;
